import { practitionerCountriesQuery_practitionerCountries } from 'Services/BeGateway/Practitioner/__generated__/practitionerCountriesQuery';
import { Namespace, ParseKeys } from 'i18next';
import i18n from 'i18n/config';

export default (country: practitionerCountriesQuery_practitionerCountries) => {
  if (country?.isoCodeTwo) {
    return i18n.t(
      `country:${country?.isoCodeTwo}` as ParseKeys<Namespace<'country'>>,
    );
  }

  if (country?.name) {
    return country?.name;
  }

  return '';
};
